import React, { useMemo, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BarChart3, Building2, LayoutGrid } from "lucide-react";
import PortalSidebar from "../nyafaz-ep/admin-shared/PortalSidebar";
import { confirmAndLogout } from "../enterprise-portal/utils/auth";
import nyafazLogo from "../salon-admin/assets/nyafazlogo.png";
import { ENTERPRISE_ADMIN_BASE } from "../enterprise-portal/utils/portalProducts";

const NaturalsAdminSidebar = ({ expanded, setExpanded }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [viewport, setViewport] = useState("desktop");

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 768) setViewport("mobile");
      else if (w < 1367) setViewport("tablet");
      else setViewport("desktop");
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const menuItems = useMemo(
    () => [
      {
        key: "ent-overview",
        sectionId: "overview",
        IconComponent: LayoutGrid,
        label: "Overview",
        to: `${ENTERPRISE_ADMIN_BASE}/overview`,
      },
      {
        key: "ent-orgs",
        sectionId: "organization",
        IconComponent: Building2,
        label: "Organizations",
        to: `${ENTERPRISE_ADMIN_BASE}/organizations`,
      },
      {
        key: "ent-analytics",
        sectionId: "analytics",
        IconComponent: BarChart3,
        label: "Analytics",
        to: `${ENTERPRISE_ADMIN_BASE}/analytics`,
      },
      {
        key: "portal-home",
        sectionId: "platform",
        IconComponent: LayoutGrid,
        label: "Nyafaz Portal",
        to: "/enterprise-portal/home",
      },
    ],
    [],
  );

  const isCompactViewport = viewport === "tablet" || viewport === "mobile";

  return (
    <PortalSidebar
      menuItems={menuItems}
      logoSrc={nyafazLogo}
      logoFallback={nyafazLogo}
      expanded={expanded}
      setExpanded={setExpanded}
      onLogout={() => confirmAndLogout(navigate)}
      isCompactViewport={isCompactViewport}
      locationPathname={location.pathname}
    />
  );
};

export default NaturalsAdminSidebar;
